import { ParsedUrlQuery } from "querystring";

export const getRedirFromQueryValue = (
	value: string | string[] | undefined,
): string | undefined => {
	if (Array.isArray(value)) return value[0];
	return value;
};

export const getRedirFromQuery = (
	query: ParsedUrlQuery,
): string | undefined => {
	return getRedirFromQueryValue(query.redir);
};

export const isSafeInternalRedirPath = (value: string): boolean => {
	if (!value.startsWith("/")) return false;
	if (value.startsWith("//")) return false;
	if (value.includes("://")) return false;
	return true;
};

export const resolvePartnerRedirOrFallback = ({
	redir,
	fallback = "/portfolios",
}: {
	redir: string | undefined;
	fallback?: string;
}): string => {
	if (!redir) return fallback;

	let decoded = redir;
	try {
		decoded = decodeURIComponent(redir);
	} catch {
		return fallback;
	}

	const normalized = decoded.trim();
	if (!normalized) return fallback;

	return isSafeInternalRedirPath(normalized) ? normalized : fallback;
};

export const withRedirQuery = ({
	signInPath,
	redirPath,
}: {
	signInPath: string;
	redirPath: string;
}): string => {
	const encodedRedir = encodeURIComponent(redirPath);
	const separator = signInPath.includes("?") ? "&" : "?";
	return `${signInPath}${separator}redir=${encodedRedir}`;
};
